import React from "react";
// import React, {useEffect} from 'react';
// import { Row, Col } from 'react-bootstrap';
// import Tabs from 'react-bootstrap/Tabs';
// import Tab from 'react-bootstrap/Tab';
// import AOS from 'aos';
// import "aos/dist/aos.css";
// import { LazyLoadImage } from 'react-lazy-load-image-component';
// import 'react-lazy-load-image-component/src/effects/blur.css';

const Services = () => {
  // useEffect(() => {
  //     AOS.init({
  //       duration: 2000,
  //     });
  //   }, []);
  return (
    <section className="expertize-sec">
      {/* <section id="our-services-sec" className="pt-5">
             <h4 className="title-blue-bar ml-5 mb-2">Our Services</h4>
             <p className="overview-black ml-5 mb-4">Keeping focus on innovation and digitalization while providing industry-leading solutions</p>
             <Tabs defaultActiveKey="software-development" id="uncontrolled-tab-example" className="mb-5 ml-5">
                <Tab eventKey="software-development" title="Software Development">
                    <Row className="m-0 flex-md-row-reverse">
                        <Col xs={12} md={6} className="service-img text-center">
                            <div>
                                <span className="serviceservice1"></span>
                            </div> 
                        </Col>
                        <Col xs={12} md={6} className="service-desc d-flex justify-content-center flex-column">
                            <h2>Software Development</h2>
                            <p className="mt-4 mr-5">Businesses lean on us to create cloud-based, integrated, robust and scalable enterprise applications.</p>
                        </Col>
                    </Row>
                </Tab>
                <Tab eventKey="UI/UX-designing" title="User Experience">
                    <Row className="m-0 flex-md-row-reverse">
                        <Col xs={12} md={6} className="service-img text-center">
                            <div>
                                <span className="serviceservice2"></span>
                            </div> 
                        </Col>
                        <Col xs={12} md={6} className="service-desc d-flex justify-content-center flex-column">
                            <h2>Mobile & Web</h2>
                            <p className="mt-4 mr-5">We live and breathe mobile & web. We design and develop enterprise-grade applications based on the latest technology.</p>
                        </Col>
                    </Row>
                </Tab>
                <Tab eventKey="QA-testing" title="Quality Assurance">
                    <Row className="m-0 flex-md-row-reverse">
                        <Col xs={12} md={6} className="service-img text-center">
                            <div>
                                <span className="serviceservice4"></span>
                            </div> 
                        </Col>
                        <Col xs={12} md={6} className="service-desc d-flex justify-content-center flex-column">
                            <h2>Quality Assurance</h2>
                            <p className="mt-4 mr-5">Our quality assurance strategies include manual and automated testing for market readiness.</p>
                        </Col>
                    </Row>
                </Tab>
                <Tab eventKey="devOps" title="DevOps">
                    <Row className="m-0 flex-md-row-reverse">
                        <Col xs={12} md={6} className="service-img text-center">
                            <div>
                                <span className="serviceservice5"></span>
                            </div> 
                        </Col>
                        <Col xs={12} md={6} className="service-desc d-flex justify-content-center flex-column">
                            <h2>DevOps</h2>
                            <p className="mt-4 mr-5">We automate the processes between development and IT, in order to build, test and release software faster and more reliably.</p>
                        </Col>
                    </Row>
                </Tab>
                <Tab eventKey="disaster-recovery" title="Disaster Recovery">
                    <Row className="m-0 flex-md-row-reverse">
                        <Col xs={12} md={6} className="service-img text-center">
                            <div>
                                <span className="serviceservice6"></span>
                            </div> 
                        </Col>
                        <Col xs={12} md={6} className="service-desc d-flex justify-content-center flex-column">
                            <h2>Disaster Recovery</h2>
                            <p className="mt-4 mr-5">We offer a cloud computing service model that allows an organization to back up its data and IT infrastructure in our cloud computing environment.</p>
                        </Col>
                    </Row>
                </Tab>
            </Tabs> 
        </section>*/}
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-12">
            <h4 className="title-blue-bar ml-5 mb-2">How we serve</h4>
            <p className="overview-black ml-5 mb-4">
              Focusing on innovation and digitalization while providing
              industry-leading solutions.
            </p>
          </div>
        </div>
      </div>
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-12">
            {/* <h4 className="title-blue-bar ml-5 mb-2">Our Services</h4>
                        <p className="overview-black ml-5 mb-4">Keeping focus on innovation and digitalization while providing industry-leading solutions</p> */}
            <div className="expertize-items">
              <div className="row">
                <div className="col-lg-4 col-md-6 my-2">
                  <div className="expertize-item">
                    <h4 className="d-flex justify-content-between align-items-center w-100">
                      <span className="expertize-label">
                        Custom Software Development
                      </span>
                      <span className="expertize-icon">
                        <i className="graph">
                          <svg
                            width="50"
                            height="50"
                            viewBox="0 0 71.124 71.124"
                          >
                            <path
                              className="a"
                              fill="#08a8f2"
                              d="M67.916,11.669H53.343a1.042,1.042,0,1,0,0,2.084H67.916a1.125,1.125,0,0,1,1.124,1.124V55a1.125,1.125,0,0,1-1.124,1.124H3.208A1.125,1.125,0,0,1,2.084,55V14.877a1.125,1.125,0,0,1,1.124-1.124H26.1v2.084H5.209a1.041,1.041,0,0,0-1.042,1.042V44.406a1.042,1.042,0,1,0,2.084,0V17.92H26.1v5.589l-4.46,2.131a1.049,1.049,0,0,0-.593.94V43.571a1.042,1.042,0,0,0,.593.94L35.113,50.95a1.056,1.056,0,0,0,.9,0l7.575-3.619a1.042,1.042,0,1,0-.9-1.88L36.6,48.357V33.675l11.391-5.442V42.915l-1.548.739a1.042,1.042,0,0,0,.9,1.88l2.141-1.022a1.042,1.042,0,0,0,.593-.94V26.58a1.048,1.048,0,0,0-.593-.94l-4.46-2.131V17.92H64.873V51.954H6.251v-3.1a1.042,1.042,0,1,0-2.084,0V53a1.041,1.041,0,0,0,1.042,1.042H65.915A1.041,1.041,0,0,0,66.957,53V16.878a1.041,1.041,0,0,0-1.042-1.042H45.026V13.753H48.9a1.042,1.042,0,0,0,0-2.084H45.026V9.585h9.342a1.041,1.041,0,0,0,1.042-1.042V6.072a3.126,3.126,0,1,0-2.084,0V7.5H43.984a1.041,1.041,0,0,0-1.042,1.042v3.126H36.6v-5.6a3.126,3.126,0,1,0-2.084,0v5.6H28.182V8.543A1.041,1.041,0,0,0,27.14,7.5H17.8V6.072a3.126,3.126,0,1,0-2.084,0V8.543a1.041,1.041,0,0,0,1.042,1.042H26.1v2.084H3.208A3.212,3.212,0,0,0,0,14.877V55a3.212,3.212,0,0,0,3.208,3.208H25.8a9.93,9.93,0,0,1-3.727,6.668H17.642a3.126,3.126,0,1,0,0,6.251h35.84a3.126,3.126,0,1,0,0-6.251H49.058a10.027,10.027,0,0,1-3.728-6.668H67.916A3.212,3.212,0,0,0,71.124,55V14.877A3.212,3.212,0,0,0,67.916,11.669ZM54.368,2.084a1.042,1.042,0,1,1-1.042,1.042A1.043,1.043,0,0,1,54.368,2.084Zm-18.806,0A1.042,1.042,0,1,1,34.52,3.126,1.043,1.043,0,0,1,35.562,2.084Zm-18.806,0a1.042,1.042,0,1,1-1.042,1.042A1.043,1.043,0,0,1,16.757,2.084ZM28.182,17.92H34.52v1.566l-6.338,3.028ZM46.62,26.58,35.562,31.863,24.5,26.58,35.562,21.3ZM23.129,28.233,34.52,33.675V48.357L23.129,42.915Zm19.813-5.719L36.6,19.486V17.92h6.338Zm0-8.761v2.084H36.6V13.753Zm-8.422,0v2.084H28.182V13.753ZM54.524,68a1.043,1.043,0,0,1-1.042,1.042H17.642a1.042,1.042,0,0,1,0-2.084h35.84A1.043,1.043,0,0,1,54.524,68ZM46.07,64.873H25.054a11.75,11.75,0,0,0,2.836-6.668H43.233A11.75,11.75,0,0,0,46.07,64.873Zm0,0"
                            />
                          </svg>
                        </i>
                      </span>
                    </h4>
                    <p>
                      Businesses lean on us as we deliver unparalleled value to
                      our clients by creating customizable, robust and scalable
                      enterprise applications.
                    </p>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6 my-2">
                  <div className="expertize-item">
                    <h4 className="d-flex justify-content-between align-items-center w-100">
                      <span className="expertize-label">
                        User Experience (UI/UX)
                      </span>
                      <span className="expertize-icon">
                        <i className="graph">
                          <svg
                            width="50"
                            height="50"
                            viewBox="0 0 82.768 96.948"
                          >
                            <path
                              d="M55.234,3.036c19.485,0,35.35,15.53,35.35,34.67A34.155,34.155,0,0,1,86.75,53.463a1.65,1.65,0,0,1-2.868.114,1.7,1.7,0,0,1-.065-1.684A30.681,30.681,0,0,0,87.3,37.706c0-17.336-14.324-31.34-32.062-31.34-17.158,0-31.155,13.119-31.957,29.815a1.565,1.565,0,0,1-.09.463l-.092.218L11.986,59.075l.3.775,9.862,3.934a1.662,1.662,0,0,1,1,1.2l.036.33V80.808a2.727,2.727,0,0,0,2.3,2.618l.44.036H45.436a1.651,1.651,0,0,1,1.612,1.329l.034.335V98.294a1.677,1.677,0,0,1-.818,1.464,1.626,1.626,0,0,1-1.653,0,1.664,1.664,0,0,1-.786-1.114l-.032-.357V87.355l-.562-.564H25.911a6.039,6.039,0,0,1-6-5.408l-.029-.573V66.847l-.353-.523L8.84,62.045a1.665,1.665,0,0,1-.919-.956,1.694,1.694,0,0,1-.05-1.013l.123-.325,12.1-24.374C21.316,17.208,36.653,3.036,55.234,3.036ZM81.352,61.105h.35l.306.065a1.661,1.661,0,0,1,1.136,1.318l.023.321V98.294a1.677,1.677,0,0,1-.818,1.464,1.626,1.626,0,0,1-1.653,0,1.664,1.664,0,0,1-.786-1.114l-.032-.357V62.8a1.684,1.684,0,0,1,.535-1.266,1.637,1.637,0,0,1,.937-.425ZM55.442,11.81a29.454,29.454,0,0,1,17.4,5.322c4.707,3.461,7.464,8.289,7.464,13.437a15.921,15.921,0,0,1-2.533,8.172L77.1,39.816l.968,5.966a1.675,1.675,0,0,1-.074.876A26.214,26.214,0,0,0,76.843,49.8a25.219,25.219,0,0,0-1.024,6.373,2.213,2.213,0,0,1-1.347,2.041,5.738,5.738,0,0,1-1.763.665c-1.781.388-2.8.332-4.02-.476a4.984,4.984,0,0,1-2.178-2.764,5.43,5.43,0,0,1-.141-.847l-.025-.44.007-.608.1-1.731a1.667,1.667,0,0,1,.847-1.552,1.625,1.625,0,0,1,1.743.1,1.667,1.667,0,0,1,.69,1.293l-.052.965-.032,1.321.018.541a1.26,1.26,0,0,0,.023.15.625.625,0,0,0,.281.436l.2.119a4.417,4.417,0,0,0,.636.249l-.013.009.187.016a4.538,4.538,0,0,0,.631.02,2.483,2.483,0,0,0,.4-.05l.175-.054.049-.029.391-.5a29.906,29.906,0,0,1,1.047-6.216l.2-.669.382-1.154.465-1.318-1-6.054a1.692,1.692,0,0,1,.364-1.334,12.1,12.1,0,0,0,2.921-7.734c0-4.062-2.189-7.86-6.13-10.761A26.324,26.324,0,0,0,55.442,15.14,26.33,26.33,0,0,0,40,19.81c-3.939,2.9-6.13,6.7-6.13,10.759s2.187,7.85,6.13,10.759a26.27,26.27,0,0,0,15.445,4.705,27.2,27.2,0,0,0,13.143-3.24,1.628,1.628,0,0,1,1.641.031,1.675,1.675,0,0,1-.049,2.885,30.4,30.4,0,0,1-14.735,3.654,29.413,29.413,0,0,1-17.4-5.354c-4.711-3.478-7.464-8.293-7.464-13.44s2.755-9.973,7.464-13.437a29.45,29.45,0,0,1,17.4-5.322Z"
                              transform="translate(-7.816 -3.036)"
                              fill="#08f"
                            ></path>
                          </svg>
                        </i>
                      </span>
                    </h4>
                    <p>
                      We deliver human-centered digital experiences across all
                      leading devices.
                    </p>
                  </div>
                </div>
                {/* <div className="col-lg-4 col-md-6 my-2">
                  <div className="expertize-item">
                    <h4 className="d-flex justify-content-between align-items-center w-100">
                      <span className="expertize-label">Web Development</span>
                      <span className="expertize-icon">
                        <i className="graph">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="419.93"
                            height="387.946"
                            viewBox="0 0 419.93 387.946"
                          >
                            <g
                              id="web-development-svgrepo-com"
                              transform="translate(0 -15.992)"
                            >
                              <g id="Group_2746" data-name="Group 2746">
                                <g id="Group_2745" data-name="Group 2745">
                                  <path
                                    id="Path_1468"
                                    data-name="Path 1468"
                                    d="M282.895,352.367a18.641,18.641,0,0,1-5.579-5.25,18.97,18.97,0,0,1-1.771-3.125H28.282V100.276H363.906V259.414a18.712,18.712,0,0,1,15.7,11.8,18.628,18.628,0,0,1,12.58-1.92V39.561a23.594,23.594,0,0,0-23.566-23.569H23.568A23.6,23.6,0,0,0,0,39.561V348.707a23.6,23.6,0,0,0,23.568,23.568H280.747a18.659,18.659,0,0,1,2.148-19.908Zm55.13-296.8a8.7,8.7,0,0,1,8.7-8.7h8.7a8.7,8.7,0,0,1,8.7,8.7v9.863a8.7,8.7,0,0,1-8.7,8.7h-8.7a8.7,8.7,0,0,1-8.7-8.7Zm-40.465,0a8.7,8.7,0,0,1,8.7-8.7h8.7a8.7,8.7,0,0,1,8.7,8.7v9.863a8.7,8.7,0,0,1-8.7,8.7h-8.7a8.7,8.7,0,0,1-8.7-8.7Zm-40.466,0a8.7,8.7,0,0,1,8.7-8.7h8.7a8.7,8.7,0,0,1,8.7,8.7v9.863a8.7,8.7,0,0,1-8.7,8.7h-8.7a8.7,8.7,0,0,1-8.7-8.7Z"
                                    fill="#08a8f2"
                                  />
                                  <path
                                    id="Path_1469"
                                    data-name="Path 1469"
                                    d="M419.875,335.77l-2.615-14.83a3.673,3.673,0,0,0-4.255-2.979l-13.188,2.324a49.468,49.468,0,0,0-6.005-10.38l8.614-10.268a3.668,3.668,0,0,0-.453-5.174l-11.534-9.68a3.675,3.675,0,0,0-5.176.453l-8.606,10.26a49.3,49.3,0,0,0-11.271-4.1V278a3.675,3.675,0,0,0-3.673-3.674h-15.06A3.675,3.675,0,0,0,342.98,278v13.392a49.252,49.252,0,0,0-11.271,4.1L323.1,285.237a3.674,3.674,0,0,0-5.175-.453l-11.535,9.679a3.674,3.674,0,0,0-.453,5.177l8.615,10.266a49.643,49.643,0,0,0-6.005,10.38l-13.188-2.325a3.677,3.677,0,0,0-4.255,2.979l-2.614,14.83a3.672,3.672,0,0,0,2.977,4.255l13.2,2.326a49.466,49.466,0,0,0,2.073,11.812l-11.6,6.7a3.67,3.67,0,0,0-1.345,5.016l7.529,13.041a3.672,3.672,0,0,0,5.016,1.344l11.609-6.7a49.484,49.484,0,0,0,9.18,7.709l-4.584,12.593a3.672,3.672,0,0,0,2.195,4.707l14.148,5.149a3.668,3.668,0,0,0,4.708-2.194l4.583-12.593a49.943,49.943,0,0,0,11.988,0l4.584,12.593a3.671,3.671,0,0,0,3.451,2.418,3.626,3.626,0,0,0,1.256-.224l14.15-5.149a3.673,3.673,0,0,0,2.193-4.707l-4.584-12.591a49.756,49.756,0,0,0,9.18-7.709l11.609,6.7a3.683,3.683,0,0,0,1.836.492,3.745,3.745,0,0,0,.951-.125,3.672,3.672,0,0,0,2.229-1.711l7.529-13.043a3.67,3.67,0,0,0-1.345-5.016l-11.6-6.693a49.484,49.484,0,0,0,2.071-11.812l13.2-2.327a3.664,3.664,0,0,0,2.37-1.511A3.6,3.6,0,0,0,419.875,335.77Zm-65.691,23.566a20.2,20.2,0,1,1,20.2-20.2A20.2,20.2,0,0,1,354.184,359.336Z"
                                    fill="#08a8f2"
                                  />
                                  <g id="Group_2744" data-name="Group 2744">
                                    <path
                                      id="Path_1470"
                                      data-name="Path 1470"
                                      d="M164.7,235.373a12.3,12.3,0,0,0-7.1-11.119l-39.455-18.332L157.6,187.588a12.3,12.3,0,0,0,7.1-11.118v-.319a12.24,12.24,0,0,0-12.271-12.25,12.327,12.327,0,0,0-5.16,1.133L84.186,194.367a12.3,12.3,0,0,0-7.092,11.117v.877a12.319,12.319,0,0,0,7.093,11.118l63.084,29.336A12.263,12.263,0,0,0,164.7,235.694v-.321Z"
                                      fill="#08a8f2"
                                    />
                                    <path
                                      id="Path_1471"
                                      data-name="Path 1471"
                                      d="M226.932,134.012a12.3,12.3,0,0,0-9.9-5.03h-.314a12.224,12.224,0,0,0-11.679,8.516L163.478,266.27a12.264,12.264,0,0,0,11.682,15.991h.315a12.217,12.217,0,0,0,11.672-8.516L228.7,144.983A12.291,12.291,0,0,0,226.932,134.012Z"
                                      fill="#08a8f2"
                                    />
                                    <path
                                      id="Path_1472"
                                      data-name="Path 1472"
                                      d="M308,194.366l-63.079-29.333a12.262,12.262,0,0,0-17.428,11.118v.319a12.32,12.32,0,0,0,7.1,11.123l39.454,18.33L234.59,224.254a12.3,12.3,0,0,0-7.1,11.119v.321a12.267,12.267,0,0,0,17.433,11.118l63.082-29.336a12.31,12.31,0,0,0,7.088-11.114v-.877A12.313,12.313,0,0,0,308,194.366Z"
                                      fill="#08a8f2"
                                    />
                                  </g>
                                </g>
                              </g>
                            </g>
                          </svg>
                        </i>
                      </span>
                    </h4>
                    <p>
                        We help you enhance your online presence by providing specialized services in website designing & website development.
                    </p>
                  </div>
                </div> */}
                <div className="col-lg-4 col-md-6 my-2">
                  <div className="expertize-item">
                    <h4 className="d-flex justify-content-between align-items-center w-100">
                      <span className="expertize-label">
                        Wearable, Web & Mobile
                      </span>
                      <span className="expertize-icon">
                        <i className="graph">
                          <svg
                            width="50"
                            height="50"
                            viewBox="0 0 77.799 77.799"
                          >
                            <path
                              d="M73.131,18.412H51.347V4.668A4.673,4.673,0,0,0,46.679,0H4.668A4.673,4.673,0,0,0,0,4.668V73.131A4.673,4.673,0,0,0,4.668,77.8H46.679a4.673,4.673,0,0,0,4.668-4.668V59.387H73.131A4.673,4.673,0,0,0,77.8,54.719V23.08a4.673,4.673,0,0,0-4.668-4.668Zm1.555,4.668v8.429H33.358V23.08a1.559,1.559,0,0,1,1.555-1.557H73.131A1.558,1.558,0,0,1,74.687,23.08ZM4.668,3.112H46.679a1.557,1.557,0,0,1,1.555,1.555v5.543H3.112V4.668A1.557,1.557,0,0,1,4.668,3.112ZM46.679,74.687H4.668a1.557,1.557,0,0,1-1.555-1.555V67.587H48.235v5.544A1.557,1.557,0,0,1,46.679,74.687Zm1.555-10.211H3.112V13.322H48.235v5.091H34.913a4.673,4.673,0,0,0-4.668,4.668V54.719a4.673,4.673,0,0,0,4.668,4.668H48.235Zm24.9-8.2H34.913a1.559,1.559,0,0,1-1.555-1.555V34.62H74.687v20.1a1.558,1.558,0,0,1-1.555,1.555Z"
                              fill="#08f"
                            ></path>
                            <path
                              d="M25.178,16.471a1.555,1.555,0,0,0,0,3.111H35.94a1.556,1.556,0,1,0,0-3.112H25.178Zm22.3,3.117a2.175,2.175,0,0,0,.312-.031l.278-.093.281-.139a3.023,3.023,0,0,0,.235-.2,1.561,1.561,0,0,0,0-2.194,1.591,1.591,0,0,0-1.7-.343,1.885,1.885,0,0,0-.512.343,1.565,1.565,0,0,0,1.1,2.662Zm4.87,0a1.91,1.91,0,0,0,.295-.031c.093-.031.2-.062.3-.093.093-.046.185-.093.265-.139a1,1,0,0,0,.231-.2,1.523,1.523,0,0,0,0-2.194,1.586,1.586,0,0,0-1.7-.343,1.607,1.607,0,0,0-.5.343,1.557,1.557,0,0,0,0,2.194,1.556,1.556,0,0,0,1.1.468Zm4.855,0a2.175,2.175,0,0,0,.312-.031l.278-.093.282-.139a2.737,2.737,0,0,0,.231-.2,1.556,1.556,0,0,0-1.7-2.537,1.885,1.885,0,0,0-.512.343,1.561,1.561,0,0,0,0,2.194,1.586,1.586,0,0,0,1.1.468Z"
                              transform="translate(12.83 8.945)"
                              fill="#08f"
                            ></path>
                          </svg>
                        </i>
                      </span>
                    </h4>
                    <p>
                      We design and develop wearable, web and mobile
                      applications to enhance your reach in the market.
                    </p>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6 my-2">
                  <div className="expertize-item">
                    <h4 className="d-flex justify-content-between align-items-center w-100">
                      <span className="expertize-label">
                        Big Data/Business Intelligence
                      </span>
                      <span className="expertize-icon">
                        <i className="graph">
                          <svg
                            width="50"
                            height="50"
                            viewBox="0 0 77.624 77.624"
                          >
                            <g transform="translate(0)">
                              <path
                                className="a"
                                fill="#08a8f2"
                                d="M77.623,38.718A14.64,14.64,0,0,0,63.434,24.107a24.767,24.767,0,0,0-16.829-17.5,1.516,1.516,0,1,0-.877,2.9A21.742,21.742,0,0,1,60.75,25.948a1.515,1.515,0,0,0,1.572,1.208c.253-.014.474-.021.676-.021a11.585,11.585,0,0,1,3.1,22.75V45.547a6.039,6.039,0,0,0-6.032-6.032H56.138a4.548,4.548,0,0,0-.9-1.516A4.529,4.529,0,0,0,56.4,34.966V28.9a4.554,4.554,0,0,0-4.548-4.548H25.773A4.554,4.554,0,0,0,21.225,28.9v6.064A4.529,4.529,0,0,0,22.387,38a4.546,4.546,0,0,0-.9,1.516H17.554a6.039,6.039,0,0,0-6.032,6.032V50.3H10.91A7.872,7.872,0,0,1,7.951,35.135a1.516,1.516,0,0,0,.91-1.737,7.867,7.867,0,0,1,8.524-9.558,1.517,1.517,0,0,0,1.582-.985A21.9,21.9,0,0,1,33.039,9.535a1.516,1.516,0,1,0-.887-2.9A24.957,24.957,0,0,0,16.534,20.761,10.9,10.9,0,0,0,5.7,32.85a10.9,10.9,0,0,0,5.21,20.486h.611v20.14H9.7a1.516,1.516,0,0,0-1.516,1.516,8.2,8.2,0,0,0,8.187,8.187H61.25a8.2,8.2,0,0,0,8.187-8.187,1.516,1.516,0,0,0-1.516-1.516H66.1V53.005A14.626,14.626,0,0,0,77.623,38.718ZM53.366,53.159v6.064A1.517,1.517,0,0,1,51.85,60.74H25.773a1.517,1.517,0,0,1-1.516-1.516V53.159a1.517,1.517,0,0,1,1.516-1.516H51.85A1.517,1.517,0,0,1,53.366,53.159Zm0-12.129V47.1a1.517,1.517,0,0,1-1.516,1.516H25.773A1.517,1.517,0,0,1,24.257,47.1V41.031a1.517,1.517,0,0,1,1.516-1.516H51.85A1.517,1.517,0,0,1,53.366,41.031ZM24.257,28.9a1.517,1.517,0,0,1,1.516-1.516H51.85A1.517,1.517,0,0,1,53.366,28.9v6.064a1.517,1.517,0,0,1-1.516,1.516H25.773a1.517,1.517,0,0,1-1.516-1.516ZM61.25,80.146H16.373a5.164,5.164,0,0,1-4.927-3.639H66.177A5.164,5.164,0,0,1,61.25,80.146Zm-46.7-6.671V45.546a3,3,0,0,1,3-3h3.672V47.1a4.529,4.529,0,0,0,1.162,3.032,4.529,4.529,0,0,0-1.162,3.032v6.064a4.553,4.553,0,0,0,4.548,4.548H51.85A4.553,4.553,0,0,0,56.4,59.224V53.159a4.529,4.529,0,0,0-1.162-3.032A4.529,4.529,0,0,0,56.4,47.1V42.547h3.671a3,3,0,0,1,3,3V73.475Zm0,0"
                                transform="translate(0 -5.554)"
                              />
                              <path
                                className="a"
                                fill="#08a8f2"
                                d="M181.594,327.032a1.517,1.517,0,1,0-1.071-.444A1.527,1.527,0,0,0,181.594,327.032Zm0,0"
                                transform="translate(-152.777 -274.879)"
                              />
                              <path
                                className="a"
                                fill="#08a8f2"
                                d="M217.727,327.032a1.516,1.516,0,1,0-1.072-.444A1.526,1.526,0,0,0,217.727,327.032Zm0,0"
                                transform="translate(-183.432 -274.879)"
                              />
                              <path
                                className="a"
                                fill="#08a8f2"
                                d="M265.86,327.032h7.31a1.516,1.516,0,0,0,0-3.032h-7.31a1.516,1.516,0,1,0,0,3.032Zm0,0"
                                transform="translate(-224.267 -274.879)"
                              />
                              <path
                                className="a"
                                fill="#08a8f2"
                                d="M181.594,247.032a1.517,1.517,0,1,0-1.071-.444A1.527,1.527,0,0,0,181.594,247.032Zm0,0"
                                transform="translate(-152.777 -207.007)"
                              />
                              <path
                                className="a"
                                fill="#08a8f2"
                                d="M217.727,247.032a1.516,1.516,0,1,0-1.072-.444A1.526,1.526,0,0,0,217.727,247.032Zm0,0"
                                transform="translate(-183.432 -207.007)"
                              />
                              <path
                                className="a"
                                fill="#08a8f2"
                                d="M265.86,247.032h7.31a1.516,1.516,0,1,0,0-3.032h-7.31a1.516,1.516,0,1,0,0,3.032Zm0,0"
                                transform="translate(-224.267 -207.007)"
                              />
                              <path
                                className="a"
                                fill="#08a8f2"
                                d="M181.594,167.032a1.518,1.518,0,1,0-1.071-.444A1.527,1.527,0,0,0,181.594,167.032Zm0,0"
                                transform="translate(-152.777 -139.136)"
                              />
                              <path
                                className="a"
                                fill="#08a8f2"
                                d="M217.727,167.032a1.516,1.516,0,1,0-1.072-.444A1.526,1.526,0,0,0,217.727,167.032Zm0,0"
                                transform="translate(-183.432 -139.136)"
                              />
                              <path
                                className="a"
                                fill="#08a8f2"
                                d="M265.86,167.032h7.31a1.516,1.516,0,0,0,0-3.032h-7.31a1.516,1.516,0,1,0,0,3.032Zm0,0"
                                transform="translate(-224.267 -139.136)"
                              />
                              <path
                                className="a"
                                fill="#08a8f2"
                                d="M251.516,3.032a1.516,1.516,0,0,0,1.516-1.516,1.516,1.516,0,1,0-2.588,1.072A1.528,1.528,0,0,0,251.516,3.032Zm0,0"
                                transform="translate(-212.098)"
                              />
                            </g>
                          </svg>
                        </i>
                      </span>
                    </h4>
                    <p>
                      Get insights based on large volumes of structured and
                      unstructured information for improved decision making.
                    </p>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6 my-2">
                  <div className="expertize-item">
                    <h4 className="d-flex justify-content-between align-items-center w-100">
                      <span className="expertize-label">DevOps</span>
                      <span className="expertize-icon">
                        <i className="graph">
                          <svg
                            width="50"
                            height="50"
                            viewBox="0 0 87.273 77.314"
                          >
                            <path
                              d="M72.585,72.555H3.591A3.393,3.393,0,0,1,.2,69.166V10.121A3.394,3.394,0,0,1,3.591,6.732h9.53a1.419,1.419,0,0,1,0,2.838H3.591a.55.55,0,0,0-.551.551V69.166a.552.552,0,0,0,.551.553H72.585a.552.552,0,0,0,.553-.553v-9.52a1.419,1.419,0,0,1,2.838,0v9.522A3.394,3.394,0,0,1,72.585,72.555Z"
                              transform="translate(-0.202 4.759)"
                              fill="#08f"
                            ></path>
                            <path
                              d="M12.258,17.047H2.368a1.418,1.418,0,0,1,0-2.837h9.889a1.418,1.418,0,0,1,0,2.837Z"
                              transform="translate(0.366 10.44)"
                              fill="#08f"
                            ></path>
                            <path
                              d="M79.121,66.023H10.127a3.393,3.393,0,0,1-3.389-3.389V3.589A3.393,3.393,0,0,1,10.127.2H79.121A3.393,3.393,0,0,1,82.51,3.589V62.634A3.393,3.393,0,0,1,79.121,66.023ZM10.127,3.039a.552.552,0,0,0-.553.551V62.634a.553.553,0,0,0,.553.553H79.121a.551.551,0,0,0,.551-.553V3.589a.552.552,0,0,0-.551-.551Z"
                              transform="translate(4.763 -0.202)"
                              fill="#08f"
                            ></path>
                            <path
                              d="M80.524,13.479H8.905a1.419,1.419,0,1,1,0-2.838H80.524a1.419,1.419,0,0,1,0,2.838ZM20.98,6.618H15.713a1.418,1.418,0,0,1,0-2.837H20.98a1.418,1.418,0,1,1,0,2.837Zm11.991,0H27.706a1.418,1.418,0,1,1,0-2.837h5.267a1.418,1.418,0,1,1,0,2.837ZM24.777,36.39l11.406,4.675-.836,2.465-13.88-5.86V35.109l13.88-5.862.836,2.467Zm15.39,15.5H37.115l10.892-31H51ZM51.929,31.714l.834-2.467,13.88,5.863v2.56l-13.88,5.862-.834-2.465,11.4-4.675Z"
                              transform="translate(5.331 2.517)"
                              fill="#08f"
                            ></path>
                          </svg>
                        </i>
                      </span>
                    </h4>
                    <p>
                      We automate the processes between development and IT in
                      order to build, test and release software faster.
                    </p>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6 my-2">
                  <div className="expertize-item">
                    <h4 className="d-flex justify-content-between align-items-center w-100">
                      <span className="expertize-label">Chatbot</span>
                      <span className="expertize-icon">
                        <i className="graph">
                          <svg
                            width="50"
                            height="50"
                            viewBox="0 0 73.692 73.692"
                          >
                            <g transform="translate(-1 -0.905)">
                              <path
                                className="a"
                                fill="#08a8f2"
                                d="M64.24,41.054H60.675V37.488a5.95,5.95,0,0,0-5.943-5.943H48.789V27.979A1.189,1.189,0,0,0,47.6,26.791H38.092V24.245a4.754,4.754,0,1,0-2.377,0v2.546H26.206a1.189,1.189,0,0,0-1.189,1.189v3.566H19.074a5.95,5.95,0,0,0-5.943,5.943v3.566H9.566A3.57,3.57,0,0,0,6,44.619V58.882a3.57,3.57,0,0,0,3.566,3.566h3.566v3.566a5.95,5.95,0,0,0,5.943,5.943H54.732a5.95,5.95,0,0,0,5.943-5.943V62.448H64.24a3.57,3.57,0,0,0,3.566-3.566V44.619A3.57,3.57,0,0,0,64.24,41.054ZM34.526,19.659A2.377,2.377,0,1,1,36.9,22.036,2.38,2.38,0,0,1,34.526,19.659ZM9.566,60.071a1.191,1.191,0,0,1-1.189-1.189V44.619a1.191,1.191,0,0,1,1.189-1.189h3.566v16.64Zm17.829-30.9H46.412v2.377H27.394ZM58.3,66.014a3.57,3.57,0,0,1-3.566,3.566H19.074a3.57,3.57,0,0,1-3.566-3.566V37.488a3.57,3.57,0,0,1,3.566-3.566H54.732A3.57,3.57,0,0,1,58.3,37.488Zm7.131-7.131a1.191,1.191,0,0,1-1.189,1.189H60.675V43.431H64.24a1.191,1.191,0,0,1,1.189,1.189Z"
                                transform="translate(0.943 2.64)"
                              />
                              <path
                                className="a"
                                fill="#08a8f2"
                                d="M44.583,46.9H23.189A1.189,1.189,0,0,0,22,48.094v1.189a11.886,11.886,0,0,0,23.772,0V48.094A1.189,1.189,0,0,0,44.583,46.9Zm-10.7,11.886a9.52,9.52,0,0,1-9.509-9.509H43.394A9.52,9.52,0,0,1,33.886,58.791Z"
                                transform="translate(3.96 8.675)"
                              />
                              <path
                                className="a"
                                fill="#08a8f2"
                                d="M27.509,41.659a4.754,4.754,0,1,0-4.754,4.754A4.759,4.759,0,0,0,27.509,41.659Zm-7.131,0a2.377,2.377,0,1,1,2.377,2.377A2.38,2.38,0,0,1,20.377,41.659Z"
                                transform="translate(3.206 6.789)"
                              />
                              <path
                                className="a"
                                fill="#08a8f2"
                                d="M42.754,36.9a4.754,4.754,0,1,0,4.754,4.754A4.759,4.759,0,0,0,42.754,36.9Zm0,7.131a2.377,2.377,0,1,1,2.377-2.377A2.38,2.38,0,0,1,42.754,44.036Z"
                                transform="translate(6.977 6.789)"
                              />
                              <path
                                className="a"
                                fill="#08a8f2"
                                d="M19.177,26.706a1.188,1.188,0,0,0,2.029-.84V22.3h7.131A3.57,3.57,0,0,0,31.9,18.734V4.471A3.57,3.57,0,0,0,28.337.9H4.566A3.57,3.57,0,0,0,1,4.471V18.734A3.57,3.57,0,0,0,4.566,22.3H14.771Zm-15.8-7.972V4.471A1.191,1.191,0,0,1,4.566,3.282H28.337a1.191,1.191,0,0,1,1.189,1.189V18.734a1.191,1.191,0,0,1-1.189,1.189h-8.32a1.189,1.189,0,0,0-1.189,1.189V23L16.1,20.271a1.188,1.188,0,0,0-.84-.348H4.566a1.19,1.19,0,0,1-1.189-1.189Z"
                                transform="translate(0 0)"
                              />
                              <path
                                className="a"
                                fill="#08a8f2"
                                d="M64.337,4.9H40.566A3.57,3.57,0,0,0,37,8.471V22.734A3.57,3.57,0,0,0,40.566,26.3H47.7v3.566a1.188,1.188,0,0,0,2.029.84L54.132,26.3H64.337A3.57,3.57,0,0,0,67.9,22.734V8.471a3.57,3.57,0,0,0-3.566-3.566Zm1.189,17.829a1.191,1.191,0,0,1-1.189,1.189H53.64a1.185,1.185,0,0,0-.84.348L50.074,27V25.111a1.189,1.189,0,0,0-1.189-1.189h-8.32a1.191,1.191,0,0,1-1.189-1.189V8.471a1.191,1.191,0,0,1,1.189-1.189H64.337a1.191,1.191,0,0,1,1.189,1.189Z"
                                transform="translate(6.789 0.754)"
                              />
                              <path
                                className="a"
                                fill="#08a8f2"
                                d="M5,4.9H26.394V7.282H5Z"
                                transform="translate(0.754 0.754)"
                              />
                              <path
                                className="a"
                                fill="#08a8f2"
                                d="M5,12.9H26.394v2.377H5Z"
                                transform="translate(0.754 2.263)"
                              />
                              <path
                                className="a"
                                fill="#08a8f2"
                                d="M7,8.9H23.64v2.377H7Z"
                                transform="translate(1.131 1.509)"
                              />
                              <path
                                className="a"
                                fill="#08a8f2"
                                d="M41,8.9H62.394v2.377H41Z"
                                transform="translate(7.543 1.509)"
                              />
                              <path
                                className="a"
                                fill="#08a8f2"
                                d="M41,16.9H62.394v2.377H41Z"
                                transform="translate(7.543 3.017)"
                              />
                              <path
                                className="a"
                                fill="#08a8f2"
                                d="M43,12.9H59.64v2.377H43Z"
                                transform="translate(7.92 2.263)"
                              />
                            </g>
                          </svg>
                        </i>
                      </span>
                    </h4>
                    <p>
                      Based on AI, NLP and deep learning, we develop
                      personalized chatbots that respond to queries and make
                      proactive suggestions.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
